/**
 * JQuery
 */

import $ from "jquery";

window.jQuery = $;
window.$ = $;

/**
 * Bootstrap
 */

import {
  // Alert,       // Dismissible alerts
  // Button,      // Toggle button states
  // Carousel,    // Slideshow component
  // Collapse,    // Accordion-like collapsing elements
  Dropdown,    // Dropdown menus
  Modal,       // Popup modals
  Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  // Tab,         // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  // Tooltip      // Tooltips for elements (requires @popperjs/core)
} from 'bootstrap';

/**
 * Init Bootstrap components that rely on JS
 */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    new Dropdown(el);
  });

  document.querySelectorAll('.offcanvas').forEach((el) => {
    new Offcanvas(el);
  });
});

/**
 * Swiper
 */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

/**
 * GSAP
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;

/**
 * Google Map
 */

import initMap from "./utils/initMap";

window.initMap = initMap;

/**
 * Utils
 */

import media from "./utils/media";
media();

import parallax from "./utils/parallax";
parallax();

/**
 * Layout
 */

import header from "./layout/header";
header();

/**
 * Partials
 */

import pageHeroSection from "./partials/pageHeroSection";
pageHeroSection();

/**
 * Blocks
 */

import blockSlider from "./blocks/blockSlider";
blockSlider();
